import { Box, Button, Fade, Modal } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
interface Props {
    open: boolean
    setOpen: (open: boolean) => void
}



export default function ModalPoliticaPrivacidade({ open, setOpen }: Props) {
    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}

        >
            <Fade in={open}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '90%', md: 1000 },
                    height: 600,
                    overflow: 'auto',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    backgroundColor: '#54d454',
                    color: '#FFFFFF',
                    borderEndStartRadius: 10,
                    borderStartStartRadius: 10,
                    borderStartEndRadius: 10,
                    borderEndEndRadius: 10,
                    p: { xs: 2, md: 4 },
                }}>
                    <p className="md:text-[38px] text-2xl font-bold text-center mt-6">
                        Política de privacidade
                    </p>
                    <div className="flex justify-end fixed top-6 right-0 h-0">
                        <Button>
                            <CloseIcon className="text-white" onClick={() => setOpen(false)} />
                        </Button>
                    </div>
                    <section className="mb-6 mt-6">
                        <h2 className="md:text-xl text-base font-semibold mb-2">1. Introdução</h2>
                        <p className="md:text-base text-sm">
                            A Forbli valoriza a privacidade de seus usuários. Esta política explica como coletamos, usamos e protegemos suas informações pessoais ao acessar o site forbli.com.br.
                        </p>
                    </section>

                    <section className="mb-6">
                        <h2 className="md:text-xl text-base font-semibold mb-2">2. Coleta de Informações</h2>
                        <p className="md:text-base text-sm">Podemos coletar os seguintes dados:</p>
                        <ul className="list-disc pl-6 space-y-1">
                            <li className="md:text-base text-sm">
                                Informações fornecidas diretamente pelo usuário, como nome, e-mail e telefone.
                            </li>
                            <li className="md:text-base text-sm">
                                Dados de navegação, como endereço IP, localização, tipo de navegador e tempo de acesso.
                            </li>
                        </ul>
                    </section>

                    <section className="mb-6">
                        <h2 className="md:text-xl text-base font-semibold mb-2">3. Uso das Informações</h2>
                        <p className="md:text-base text-sm">Os dados coletados são utilizados para:</p>
                        <ul className="list-disc pl-6 space-y-1">
                            <li className="md:text-base text-sm">
                                Melhorar a experiência no site.
                            </li>
                            <li className="md:text-base text-sm">
                                Entrar em contato com usuários para responder a solicitações ou fornecer informações relevantes.
                            </li>
                            <li className="md:text-base text-sm">
                                Desenvolver estratégias e serviços alinhados às necessidades dos usuários.
                            </li>
                        </ul>
                    </section>

                    <section className="mb-6">
                        <h2 className="md:text-xl text-base font-semibold mb-2">4. Compartilhamento de Informações</h2>
                        <p className="md:text-base text-sm">A Forbli não compartilha suas informações pessoais com terceiros, exceto:</p>
                        <ul className="list-disc pl-6 space-y-1">
                            <li className="md:text-base text-sm">
                                Quando exigido por lei.
                            </li>
                            <li className="md:text-base text-sm">
                                Com parceiros confiáveis para melhorar os serviços, mediante consentimento.
                            </li>
                        </ul>
                    </section>

                    <section className="mb-6">
                        <h2 className="md:text-xl text-base font-semibold mb-2">5. Proteção de Dados</h2>
                        <p className="md:text-base text-sm">Utilizamos medidas de segurança, como criptografia e servidores seguros, para proteger suas informações contra acesso não autorizado.</p>
                    </section>

                    <section className="mb-6">
                        <h2 className="md:text-xl text-base font-semibold mb-2">6. Cookies e Tecnologias Similares</h2>
                        <p className="md:text-base text-sm">O site utiliza cookies para melhorar sua navegação. Você pode desativar os cookies no seu navegador, mas isso pode impactar algumas funcionalidades do site.</p>
                    </section>

                    <section className="mb-6">
                        <h2 className="md:text-xl text-base font-semibold mb-2">7. Direitos do Usuário</h2>
                        <p className="md:text-base text-sm">Os usuários têm direito a:</p>
                        <ul className="list-disc pl-6 space-y-1">
                            <li className="md:text-base text-sm">
                                Solicitar acesso, correção ou exclusão de seus dados.
                            </li>
                            <li className="md:text-base text-sm">
                                Retirar o consentimento para o uso dos dados a qualquer momento.
                            </li>
                        </ul>
                    </section>

                    <section className="mb-6">
                        <h2 className="md:text-xl text-base font-semibold mb-2">8. Contato</h2>
                        <p className="md:text-base text-sm">
                            Caso tenha dúvidas sobre esta política ou queira exercer seus direitos, entre em contato conosco pelo e-mail forbli.contato@gmail.com.
                        </p>
                    </section>

                    <section>
                        <h2 className="md:text-xl text-base font-semibold mb-2">9. Alterações nesta Política</h2>
                        <p className="md:text-base text-sm">
                            Reservamo-nos o direito de atualizar esta política para refletir mudanças em nossas práticas. Recomendamos que os usuários verifiquem esta página regularmente.
                        </p>
                    </section>
                </Box>
            </Fade>
        </Modal>
    )
}